"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_BENEFITS = exports.SUBSCRIBE_BENEFIT = void 0;
const SUBSCRIBE_BENEFITS = exports.SUBSCRIBE_BENEFITS = 'subscribe-benefits';
const SUBSCRIBE_BENEFIT = exports.SUBSCRIBE_BENEFIT = 'subscribe-benefit';
//# sourceMappingURL=constants.js.map